var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-menu",
    {
      staticStyle: { "z-index": "1000" },
      attrs: { bottom: "", left: "", "offset-y": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b({ attrs: { icon: "" } }, "v-btn", attrs, false),
                  on
                ),
                [_c("v-icon", [_vm._v("mdi-dots-vertical")])],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "v-list",
        { staticStyle: { "text-align": "start" } },
        [
          _vm.notification && _vm.notification.body.activityUuid && !_vm.viewAll
            ? _c(
                "v-list-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.executeTextAction("View", _vm.notification)
                    }
                  }
                },
                [_c("v-list-item-title", [_vm._v(_vm._s(_vm.actions.view))])],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.notification && !_vm.viewAll
            ? _c("notification-menu-list", {
                attrs: { actions: _vm.actions, notification: _vm.notification },
                on: { executeTextAction: _vm.executeTextAction }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewAll
            ? _c("notification-read-all-menu", {
                attrs: { actions: _vm.actions, allRead: _vm.allRead },
                on: { readAllNotifications: _vm.readAllNotifications }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewAll
            ? _c(
                "v-list-item",
                { on: { click: _vm.deleteAllNotifications } },
                [
                  _c("v-list-item-title", [
                    _vm._v(_vm._s(_vm.actions.deleteAll))
                  ])
                ],
                1
              )
            : _c(
                "v-list-item",
                {
                  on: {
                    click: function($event) {
                      return _vm.executeTextAction("Delete", _vm.notification)
                    }
                  }
                },
                [_c("v-list-item-title", [_vm._v(_vm._s(_vm.actions.delete))])],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6feef26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6feef26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Notifications/_Organisms/NotificationsMenu.vue
// module id = null
// module chunks = 